import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import LanguageDetector from 'i18next-browser-languagedetector';
import { defaultLanguage } from './helper';
import commonEs from './es/common.json';
import commonEn from './en/common.json';
// not like to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: defaultLanguage,
        debug: true,
        resources: {
            en: {
                common: commonEn
            },
            es: {
                common: commonEs
            },
        },
        defaultNS: 'common',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        }
    });


export default i18n;